import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { AllGroupsPage } from '@features/groups/components/pages/AllGroupsPage'
import { SubjectsTable } from '@features/groups/components/tables/SubjectsTable'
import { groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/all/subjects')({
    component: RouteComponent,
    loader: async ({ context }) => {
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'all', type: 'programme' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load subjects'>
            <Suspense fallback={<LoadingIndicator resource='all subjects'/>}>
                <AllGroupsPage
                    title='All subjects'
                    renderTable={(columnPreset) => (
                        <SubjectsTable
                            columnPreset={columnPreset}
                            mode='all'
                            navMode='id'
                        />
                    )}
                />
            </Suspense>
        </QueryErrorBoundary>
    )
}
